import { lazy, Suspense } from 'react';
import LoadingSection from '../LoadingSection';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyTransitional = /*#__PURE__*/lazy(() => import('./ErrorSectionFormatter.transitional'));
const LazyAlpha = /*#__PURE__*/lazy(() => import('./ErrorSectionFormatter.alpha'));
const ErrorSectionFormatter = ({
  section,
  trellisComponents
}) => /*#__PURE__*/_jsx(Suspense, {
  fallback: /*#__PURE__*/_jsx(LoadingSection, {}),
  children: trellisComponents ? /*#__PURE__*/_jsx(LazyAlpha, {
    section: section
  }) : /*#__PURE__*/_jsx(LazyTransitional, {
    section: section
  })
});
export default ErrorSectionFormatter;